module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Table', {
    ref: "table",
    attrs: {
      "border": "",
      "height": _vm.height,
      "columns": _vm.innerColumns,
      "data": _vm.tableData,
      "stripe": _vm.stripe,
      "size": "large",
      "row-class-name": _vm.rowClassName
    },
    on: {
      "on-selection-change": _vm.selectionChange,
      "on-sort-change": _vm.handleSortChange
    }
  }), _vm._v(" "), _c('Page', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "total": _vm.totalCount,
      "show-elevator": "",
      "className": "page",
      "current": _vm.page.pageIndex,
      "pageSize": _vm.page.pageSize,
      "show-sizer": _vm.showSizer,
      "page-size-opts": _vm.pageSizeOpts,
      "placement": _vm.showSizer ? 'top' : 'bottom',
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePageIndex,
      "on-page-size-change": _vm.changePageSize
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ccc6262","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/List.vue
// module id = 1708
// module chunks = 8